import { render, staticRenderFns } from "./ListPanelHistory.vue?vue&type=template&id=5856f73a&scoped=true&"
import script from "./ListPanelHistory.vue?vue&type=script&lang=js&"
export * from "./ListPanelHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5856f73a",
  null
  
)

export default component.exports